export enum ApplicationState {
  INITIALIZING,
  INITIALIZED,
  READY,
  FATAL,
  UNKNOWN,
  MAINTENANCE,
  OFFLINE,
}
